import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

export const selectLoanFeeRecommendations = createSelector(
  selectLoanApplication,
  ({ feeRecommendations }) => feeRecommendations?.data || null,
);
